import { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, TextField } from '@mui/material';

export interface CreateBatchInput {
	ten: string;
	hieuLucTuNam: number;
	ghiChu?: string;
}

export interface CreateBatchDialogProps {
	open: boolean;
	isSubmitting: boolean;
	onClose: () => void;
	onSubmit: (input: CreateBatchInput) => void;
}

const currentYear = new Date().getFullYear();

export function CreateBatchDialog({ open, isSubmitting, onClose, onSubmit }: CreateBatchDialogProps) {
	const [ten, setTen] = useState('');
	const [hieuLucTuNam, setHieuLucTuNam] = useState(currentYear);
	const [ghiChu, setGhiChu] = useState('');

	const handleSubmit = () => {
		if (!ten.trim()) return;
		onSubmit({ ten: ten.trim(), hieuLucTuNam, ghiChu: ghiChu.trim() || undefined });
	};

	const handleReset = () => {
		setTen('');
		setHieuLucTuNam(currentYear);
		setGhiChu('');
	};

	return (
		<Dialog open={open} onClose={onClose} slotProps={{ transition: { onExited: handleReset } }} fullWidth maxWidth="sm">
			<DialogTitle>Tạo đợt chuyển đổi mới</DialogTitle>
			<DialogContent>
				<Stack spacing={2} sx={{ mt: 1 }}>
					<TextField label="Tên đợt" value={ten} onChange={(e) => setTen(e.target.value)} required fullWidth autoFocus />
					<TextField
						label="Năm hiệu lực"
						type="number"
						value={hieuLucTuNam}
						onChange={(e) => setHieuLucTuNam(Number(e.target.value))}
						required
						fullWidth
					/>
					<TextField label="Ghi chú" value={ghiChu} onChange={(e) => setGhiChu(e.target.value)} fullWidth multiline minRows={2} />
				</Stack>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose} disabled={isSubmitting}>
					Huỷ
				</Button>
				<Button variant="contained" onClick={handleSubmit} disabled={isSubmitting || !ten.trim()}>
					{isSubmitting ? 'Đang tạo...' : 'Tạo đợt'}
				</Button>
			</DialogActions>
		</Dialog>
	);
}
